import AnalyticsAndAdvisoryBackground from '@gc-bridge/assets/images/analytics-and-advisory-background.png';
import CommonDataServiceBackground from '@gc-bridge/assets/images/common-data-services-background.png';
import FacExchangeBackground from '@gc-bridge/assets/images/fac-exchange-background.png';
import GcMarketPlaceBackground from '@gc-bridge/assets/images/gc-market-place-background.png';
import GcmpActivityReportsBackground from '@gc-bridge/assets/images/gcmp-activity-reports-background.png';
import PortalsAndAppsBackground from '@gc-bridge/assets/images/portals-and-apps-background.png';
import SharedAndGenAiBackground from '@gc-bridge/assets/images/shared-and-genai-background.png';
import SupportServicesBackground from '@gc-bridge/assets/images/support-services-background.png';
import { Category, SectionProps } from '@gc-bridge/models';
import { AdditionalColors } from '@gc-bridge/theme/colors';

export const sections: SectionProps[] = [
  {
    separatorColor: AdditionalColors.MilkyWay,
    title: 'Engage',
    description: ' Access platforms to help you work and transact.',
    categories: [
      {
        id: Category.Treaty,
        picture: GcMarketPlaceBackground,
        title: 'Treaty',
        description:
          'End-to-end collaboration throughout the treaty project and placement lifecycle, with secure digital client and market integration.',
      },
      {
        id: Category.Facultative,
        picture: FacExchangeBackground,
        title: 'Facultative',
        description:
          'Supporting fast and efficient transacting of Facultative programs and placements.',
      },
      {
        id: Category.Shared,
        picture: SharedAndGenAiBackground,
        title: 'Shared',
        description: 'Solutions that support our business functions.',
      },
      {
        id: Category.GcAnalyticsAndAdvisory,
        picture: AnalyticsAndAdvisoryBackground,
        title: 'GC Analytics & Advisory',
        description:
          'Our advanced suite of catastrophe modeling and analytics resources.',
      },
      {
        id: Category.ClientSupportServices,
        picture: SupportServicesBackground,
        title: 'Client Support Services',
        description:
          'Enabling colleagues to perform accurate premium, claim and fiduciary accounting.',
      },
    ],
  },
  {
    backgroundColor: AdditionalColors.MilkyWay,
    separatorColor: AdditionalColors.MilkyWay,
    title: 'Enable',
    description: 'Access foundational services and support applications.',
    categories: [
      {
        id: Category.DataAndDocuments,
        picture: CommonDataServiceBackground,
        title: 'Data & Documents',
      },
      {
        id: Category.PortalsAndApplications,
        picture: PortalsAndAppsBackground,
        title: 'Portals & Applications',
      },
      {
        id: Category.GenAI,
        picture: SharedAndGenAiBackground,
        title: 'AI Tools',
      },
    ],
  },
  {
    separatorColor: AdditionalColors.NavyBlue,
    title: 'Analyze',
    description: 'Access reports, dashboards and financial analysis.',
    categories: [
      {
        id: Category.RealTimeInsights,
        picture: GcmpActivityReportsBackground,
        title: 'Real-Time Insights',
      },
    ],
  },
] as const;
